import "./index.css";

import { ApolloProvider } from "@apollo/client";
import App from "./App";
import GoogleMapWrapper from "./common/GoogleMapWrapper";
import ReactDOM from "react-dom";
import businessDays from "dayjs-business-days";
import createApolloClient from "./libs/createApolloClient";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(businessDays);
dayjs.extend(timezone);
dayjs.extend(utc);

export const url = window.location.href.includes("order-module")
  ? window.location.href.includes("order-module-dev") ? "https://order-module-api-dev.esa-logistics.eu" : "https://order-module-api.esa-logistics.eu"
  : "http://localhost:7009";

const client = createApolloClient(url + "/admin/graphql");

ReactDOM.render(
  <ApolloProvider client={client}>
    <GoogleMapWrapper>
      <App client={client} />
    </GoogleMapWrapper>
  </ApolloProvider>,
  document.getElementById("root")
);
